import { environment } from '@env'
import moment from 'moment'

export const APPLICATION_DATA = {
  BUILD_VERSION: environment.BUILD_VERSION,
  BUILD_NUM: environment.BUILD_NUM,
  BUILD_DATE: moment(environment.BUILD_DATE, 'DDMMYYYY.hhmm').format('DD-MM-YYYY'),
}
